const CenteredContainer = ({
	children,
	...props
}: React.HTMLProps<HTMLDivElement> & {
	children: JSX.Element | (JSX.Element | false)[]
}) => (
	<div
		style={{
			display: "flex",
			textAlign: "center",
			minHeight: "100vh",
			flexDirection: "column",
			alignItems: "center",
			justifyContent: "center"
		}}
		{...props}
	>
		{children}
	</div>
)

export default CenteredContainer
